import {Component, input, OnInit} from '@angular/core';
import {BasicUserDetails, ClcUnitDetails, ProjectDetails} from '../../../../api';
import {TaAppStore} from '../../../../state/clcta-store';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {AutoComplete} from 'primeng/autocomplete';
import {Button} from 'primeng/button';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {Tag} from 'primeng/tag';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {Select} from 'primeng/select';
import {IconBtnComponent} from '../../icon-b/icon-btn.component';

@Component({
  selector: 'manage-project-modal',
  imports: [
    AutoComplete,
    Button,
    FormsModule,
    InputText,
    Tag,
    ToggleSwitch,
    Select,
    ReactiveFormsModule,
    IconBtnComponent
  ],
  templateUrl: './manage-project-modal.component.html',
  styleUrl: './manage-project-modal.component.scss'
})
export class ManageProjectModalComponent implements OnInit {
  modalData = input<ProjectDetails>();
  availableApprovers = input<BasicUserDetails[]>([]);
  availableUnits = input<ClcUnitDetails[]>([]);
  localData: ProjectDetails = {
    name: '',
    code: '',
    active: true,
    approvers: [],
    unitId: '',
    unitCode: '',
    unitName: ''
  };
  // private readonly codeParts = computed(() => {
  //   const code = this.localData.code ?? '';
  //   const lastDash = code.lastIndexOf('-');
  //
  //   if (lastDash === -1) {
  //     return {
  //       start: '',
  //       end: code
  //     };
  //   }
  //   return {
  //     start: code.slice(0, lastDash + 1),
  //     end: code.slice(lastDash + 1)
  //   };
  // });
  // startOfCode = computed<string>(() => this.codeParts().start);
  // endOfCode = computed<string>(() => this.codeParts().end);

  filteredApprovers: BasicUserDetails[] = [];
  approverControl: FormControl<BasicUserDetails | null> = new FormControl<BasicUserDetails | null>(null);


  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public store: TaAppStore,
  ) {
  }


  ngOnInit() {
    if (!!this.modalData()) {
      this.localData = {...this.modalData()!, approvers: this.modalData()!.approvers?.map(approver => ({...approver})) ?? []};
    }
  }

  addApprover(): void {
    if (!!this.localData.approvers) {
      this.localData.approvers.push({...this.approverControl.value});
    } else {
      this.localData.approvers = [{...this.approverControl.value}];
    }
    this.approverControl.reset();
  }

  removeApprover(index: number): void {
    if (!!this.localData.approvers) {
      this.localData.approvers.splice(index, 1);
    }
  }

  filterApprovers(event: any): void {
    const existingIds = (this.localData.approvers ?? []).map(m => m.id);

    this.filteredApprovers = this.availableApprovers().filter(approver =>
      approver.name?.toLowerCase().includes(event.query.toLowerCase()) &&
      !(existingIds.includes(approver.id))
    );
  }

  /**
   * p-select emits onChange for a clear (null) as well as for a selection, so only a real unit
   * may touch the model - anything else would stringify into the code as "undefined-"/"null-".
   */
  updateLinkedUnit(event: any): void {
    const unit: ClcUnitDetails | undefined = event.value;
    if (!unit?.id) {
      return;
    }
    this.localData.unitId = unit.id;
    this.localData.unitCode = unit.code;
    this.localData.unitName = unit.name;
    if (this.localData.code === '') {
      this.localData.code = (unit.code ?? '') + '-';
    }
  }

  findUnit(id: string | undefined): ClcUnitDetails | undefined {
    if (!!id) {
      return this.availableUnits().find(unit => unit.id === id);
    }
    return undefined;
  }

  updateLocalCode(end: string): void {
    this.localData.code = this.startOfCode + end.replace(/-/g, '');
  }

  preventDash(event: any): void {
    if (event.key === '-') {
      event.preventDefault();
    }
  }

  /**
   * A new project has no unit until one is picked, and everything else depends on it - the code is
   * prefixed with the unit code, and the approvers only mean anything against a unit's project.
   * An existing project always arrives with a unit, so nothing is disabled when editing.
   */
  get unitSelected(): boolean {
    return !!this.localData.unitId;
  }

  /** A project is only saveable once it has a unit, a project number and a name. */
  get canSave(): boolean {
    return this.unitSelected && !!this.endOfCode.trim() && !!this.localData.name?.trim();
  }

  get startOfCode(): string {
    const code = this.localData.code ?? '';
    const index = code.lastIndexOf('-');
    return index === -1 ? '' : code.slice(0, index + 1);
  }

  get endOfCode(): string {
    const code = this.localData.code ?? '';
    const index = code.lastIndexOf('-');
    return index === -1 ? code : code.slice(index + 1);
  }

  closeDialog(data?: ProjectDetails): void {
    this.ref.close(data);
  }
}
